import { render } from "./TextBalloon.vue?vue&type=template&id=46beddb4&scoped=true&ts=true"
import script from "./TextBalloon.vue?vue&type=script&lang=ts"
export * from "./TextBalloon.vue?vue&type=script&lang=ts"

import "./TextBalloon.vue?vue&type=style&index=0&id=46beddb4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46beddb4"]])

export default __exports__